<template>
  <!-- 新建交付物 -->
  <el-dialog custom-class="new-deliver" :title="(mfgid ? '编辑' : '新建') + '交付物'" :visible.sync="dialogShow" width="600px"
    :close-on-click-modal="false" append-to-body :modal-append-to-body="false">
    <div v-loading="loading" style="width: 480px; margin: 0px auto 20px">
      <el-form ref="deliverForm" :model="deliver" :rules="deliverRules" label-position="left" label-width="120px">

        <el-form-item label="产品图" prop="thumb">

          <el-upload ref="upload" :class="{ 'show-plus': deliver.thumb }" action="" list-type="picture-card"
            :auto-upload="true" :limit="1" :multiple="false" :on-preview="handlePreview" :file-list="fileList"
            :before-upload="handleBeforeUpload" :http-request="handleUploadFile">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
              <span class="el-upload-list__item-actions">
                <!-- <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
									<i class="el-icon-zoom-in"></i>
								</span>
								<span class="el-upload-list__item-delete" @click="handleDownload(file)">
									<i class="el-icon-download"></i>
								</span> -->
                <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="制号" prop="mfg_no">
          <el-input v-model="deliver.mfg_no" placeholder="请输入制号" clearable />
        </el-form-item>

        <el-form-item label="名称" prop="title">
          <el-input v-model="deliver.title" clearable placeholder="请输入名称" />
        </el-form-item>

        <el-form-item label="数量" prop="plan_num">
          <el-input v-model.number="deliver.plan_num" type="number" :min="0" clearable placeholder="数量"
            @input="checkNumber" />
        </el-form-item>

        <el-form-item label="型号" prop="model">
          <el-input v-model="deliver.model" clearable placeholder="请输入" />
        </el-form-item>

        <el-form-item label="交付日期" prop="plan_deliver_time">
          <f-date-picker v-model="deliver.plan_deliver_time" type="date" value-format="timestamp" placeholder="选择日期"
            width="100%" :disablerange="[new Date().valueOf() / 1000]"></f-date-picker>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input v-model="deliver.remark" :rows="3" type="textarea" clearable />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="text-center mb">
      <el-button plain class="extend" @click="dialogShow = false">取 消</el-button>
      <el-button type="primary" class="extend" @click="submit()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import OSS from "ali-oss"
import { preUpload, getMfgDetail, postMfg } from "@/api/pm/mfgApi"
export default {
  props: {
    show: {
      type: Boolean
    },
    mfgid: {
      type: Number
    }
  },

  components: {
    MesNumSelector: () => import('@/views/mes/components/MesNumSelector'),
    FDatePicker: () => import('@/components/FDatePicker'),
  },

  data () {
    return {
      loading: false,
      uploading: false,
      defaultDate: new Date(),
      deliver: {
        mfg_no: null,
        model: '',
        title: '',
        plan_num: null,
        plan_deliver_time: null,
        thumb: '',
        remark: ''
      },
      deliverRules: {
        // thumb: [{ required: true, message: '产品图不能为空', trigger: 'blur' }],
        mfg_no: [{ required: true, message: '制号不能为空', trigger: ['blur', 'change'] }],
        title: [{ required: true, message: '产品名称不能为空', trigger: 'blur' }],
        plan_num: [{ required: true, message: '数量不能为空', trigger: 'blur' }],
        model: [{ required: true, message: '型号不能为空', trigger: 'blur' }],
        plan_deliver_time: [{ required: true, message: '型号不能为空', trigger: ['blur', 'change'] }]
      },
      fileList: [],

      authData: {},
      ossClient: null,
      upload: {},
      checkpoints: {},
      multiPartConfig: {
        parallel: 1,
        partSize: 1024 * 1024,
        progress: this.handleUploadProgress
      },

    }
  },

  computed: {
    dialogShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    plan_deliver_time: {
      get () {
        return this.deliver.plan_deliver_time * 1000
      },
      set (val) {
        this.deliver.plan_deliver_time = val / 1000
      }
    }
  },

  created () {
    // console.log(this.mfgid);
    if (this.mfgid) {
      this.fetchData()
    }
  },
  methods: {

    fetchData () {
      getMfgDetail({ mfgid: this.mfgid }).then(res => {
        if (!res.errno) {
          this.deliver['mfgid'] = res.data.mfgid
          this.deliver.mfg_no = res.data.mfg_no
          this.deliver.model = res.data.model
          this.deliver.title = res.data.title
          this.deliver.plan_num = res.data.plan_num
          this.deliver.plan_deliver_time = res.data.plan_deliver_time
          this.deliver.thumb = res.data.thumb
          this.deliver.remark = res.data.remark
          this.fileList = res.data.thumb ? [{ url: res.data.thumb, name: '' }] : []
        }
      })

    },

    disabledDate (date) {
      return new Date(date).valueOf() > new Date().valueOf()
    },


    checkNumber (val) {
      if (val < 0) {
        this.deliver.plan_num = 0
      }

    },

    submit () {
      this.$refs.deliverForm.validate(valid => {
        if (valid) {
          this.deliver['projectid'] = Number(this.$store.state.middleStore.tmpProjectid)
          postMfg(this.deliver).then(res => {

            if (!res.errno) {
              this.$message.success(res.message)
              this.$emit('success')
            } else {
              this.$message.error(res.message)
            }
            this.dialogShow = false

          })
        }
      })

    },

    async submitUpload () {
      await this.initOssClient();
      this.$refs.upload.submit();
    },
    handleRemove (file) {
      // console.log("rm", file);
      this.deliver.thumb = ''
      this.$refs.upload.handleRemove(file);
    },
    handlePreview (file) {
      // console.log("prev:", file);
    },
    async handleBeforeUpload (file) {
      // 数据库 标记开始上传
      // const upload = await this.$axios.post("/api/AliOSS/upload", {
      // 	filename: file.name,
      // 	uploadTime: new Date(),
      // 	status: "uploading"
      // });
      this.$set(this.upload, `${file.uid}`, {
        filename: file.name,
        uploadTime: new Date(),
        status: "uploading"
      });
    },
    async handleUploadFile (param) {
      // 单片上传
      this.singlePartUpload(param.file)
      // 分片上传
      // this.multiPartUpload(param.file);
    },
    handleUploadSuccess (file, res) {
      console.log(res);
      this.upload[`${file.uid}`].status = "upload finished";
      this.deliver.thumb = res.url
    },
    handleUploadError (file, msg) {
      this.upload[`${file.uid}`].status = msg;
      // console.log(file, msg, 'eoorr');
      // this.$axios.put("/api/AliOSS/upload", this.upload[`${file.uid}`]);
    },
    handleUploadProgress (progress, checkpoint) {
      // this.$refs.uploadlog
      // console.log(progress, checkpoint);
      this.$set(this.checkpoints, `${checkpoint.uploadId}`, checkpoint);
      this.$refs.upload.handleProgress(
        {
          percent: progress * 100
        },
        checkpoint.file
      );
    },
    handleUploadStop () {
      if (this.ossClient) {
        this.ossClient.cancel();
      }
    },
    handleUploadResume () {
      this.resumeMultiPartUpload()
    },
    async initOssClient () {
      // 初始化 OSS客户端
      const auth = await preUpload();
      console.log(auth, process.env.VUE_APP_RES_URL, process.env);
      this.ossClient = new OSS({
        accessKeyId: auth.data.AccessKeyId,
        accessKeySecret: auth.data.AccessKeySecret,
        bucket: auth.data.Bucket,
        region: `oss-cn-shenzhen`,
        stsToken: auth.data.SecurityToken,
        cname: true,
        endpoint: process.env.VUE_APP_RES_URL,
      });
    },
    async multiPartUpload (file) {
      if (!this.ossClient) {
        await this.initOssClient();
      }
      this.ossClient
        .multipartUpload(file.name, file, {
          progress: this.multiPartConfig.progress
        })
        .then(res => {

          this.$refs.upload.handleSuccess(res, file)
          this.handleUploadSuccess(file, res);
          // finishUpload
        })
        .catch(res => {
          this.handleUploadError(file, res.name);
        });
    },


    async singlePartUpload (file) {
      if (!this.ossClient) {
        await this.initOssClient();
      }
      this.ossClient
        .put(new Date().valueOf() + new Date().valueOf() + file.name, file)
        .then(res => {
          // console.log(res);
          this.$refs.upload.handleSuccess(res, file)
          this.handleUploadSuccess(file, res);
        })
        .catch(res => {
          this.handleUploadError(file, res);
        });
    },


    async resumeMultiPartUpload () {
      if (!this.ossClient) {
        await this.initOssClient();
      }
      Object.values(this.checkpoints).forEach(checkpoint => {
        const { uploadId, file } = checkpoint;
        this.ossClient.multipartUpload(uploadId, file, {
          parallel: this.multiPartConfig.parallel,
          partSize: this.multiPartConfig.partSize,
          progress: this.multiPartConfig.progress,
          checkpoint: checkpoint
        }).then(res => {
          // this.$delete(this.checkpoints, uploadId)
          this.handleUploadSuccess(file, res)
        }).catch(res => {
          this.handleUploadError(file, res)
        })
      });
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 104px;
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}

.show-plus {
  /deep/.el-upload {
    display: none;
  }
}
</style>